export const OFFERS_SORT_TYPES = {
    low_rate: 'Низкие ставки',
    less_conditions: 'Упрощенные условия',
    high_approval_rate: 'Высокая вероятность одобрения'
};

export const OFFERS_SORT_ARRAY = Object.entries(OFFERS_SORT_TYPES).map(([key, value], index) => ({
    id: index + 1, title: value, key
}));
